module.exports = __webpack_public_path__ + "images/775ae40ae5b5c262cb8f2cdb09899523.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/components/QuoteSidebar/img/cc4.jpg
// module id = 1352
// module chunks = 0